import { NgModule } from '@angular/core';
import { ConfigModule, I18nModule } from '@spartacus/core';

@NgModule({
  imports: [
    I18nModule,
    ConfigModule.withConfig({
      i18n: {
        backend: {
          loader: (lng: string, ns: string) =>
            import(`../../../../public/i18n-assets/${lng}/${ns}.json`),
        },
        chunks: {
          knbrCommons: ['button', 'saved', 'label', 'knBrMessages', 'toolTip', 'httpHandlers'],
          knbrHome: ['counter', 'customer', 'quicklinks'],
          knbrCart: ['cartCommon', 'create', 'cartSearchForm', 'cartResult', 'addToCartMessage'],
          knbrQuote: [
            'quoteCommon',
            'quoteSearchForm',
            'quoteResult',
            'actionBar',
            'quoteDetailHeader',
            'quoteItems',
            'quotePartialItems',
            'addToQuoteMessage',
            'quoteReference',
          ],
          knbrInvoice: ['invoiceSearchForm', 'invoiceResult', 'knbrAccountSummary', 'knbrInvoiceDetails'],
          knbrOrder: [
            'orderHistorySearchForm',
            'orderHistoryResult',
            'knbrOrderDetails',
            'knBrOrderReturn',
            'knbrCancelOrder',
            'orderReturnResult',
            'orderReturnsSearchForm',
            'knbrReturnOrderDetails',
            'freightPopUp',
          ],
          address: ['addressForm', 'addressBook', 'addressCard'],
          payment: ['paymentForm', 'paymentMethods', 'paymentCard', 'paymentTypes'],
          myAccount: [
            'orderDetails',
            'orderHistory',
            'closeAccount',
            'updateEmailForm',
            'updatePasswordForm',
            'updateProfileForm',
            'consentManagementForm',
            'myCoupons',
            'wishlist',
            'notificationPreference',
            'myInterests',
            'AccountOrderHistoryTabContainer',
            'returnRequestList',
            'returnRequest',
          ],
          checkout: [
            'checkout',
            'checkoutAddress',
            'checkoutOrderConfirmation',
            'checkoutReview',
            'checkoutShipping',
            'checkoutProgress',
            'checkoutPO',
          ],
          knbrOrderTools: ['orderImport', 'quickOrder', 'orderForms'],
          knbrQuickEntry: ['quickEntry'],
          knbrAddress: ['knbrAddressBook', 'knbrAddressForm'],
          knbrNac: [
            'nacConfigurbaleForm',
            'downloadConfirmationDialog',
            'updateTemplateDialog',
            'uploadNewTemplateDialog',
            'nacMessages',
          ],
          knbrFactSheet: ['factSheetHeader', 'factSheetGroup', 'factSheetMaterial', 'factSheetModal'],
          user: ['anonymousConsents', 'forgottenPassword', 'loginForm', 'register', 'checkoutLogin', 'authMessages', 'KnbrProfile'],
          common: [
            'common',
            'pageMetaResolver',
            'spinner',
            'navigation',
            'searchBox',
            'sorting',
            'httpHandlers',
            'miniCart',
            'miniLogin',
            'skipLink',
            'formErrors',
            'errorHandlers'
          ],
          knbrShipment:['shipmentSearchForm','shipmentSearchResult'],
          authMessages: ['authMessages'],
        },
        fallbackLang: 'en',
      },
    }),
  ],
})
export class KnBrI18nModule {}
